import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const dashboardService = {

  getTopSellingItems: async (params) => {
    try {
      const data = await apiClient.get(ENDPOINTS.DASHBOARD.GET_TOP_SELLING, {
        params,
      });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(' Failed to fetch top selling items:', error);
      return [];
    }
  },

  getPaymentCollectionModeWise: async (params) => {
    try {
      const data = await apiClient.get(ENDPOINTS.DASHBOARD.GET_PAYMENT_MODEWISE, {
        params,
      });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(' Failed payment mode-wise collection:', error);
      return [];
    }
  },

  getRevenueTrend: async (params) => {
    try {
      return await apiClient.get(ENDPOINTS.DASHBOARD.GET_REVENUE_TREND, {
        params,
      });
    } catch (error) {
      console.error(' Failed to fetch revenue trend:', error);
      return [];
    }
  },

  getTopDish: async (params) => {
    try {
      return await apiClient.get(ENDPOINTS.DASHBOARD.GET_TOP_DISH, {
        params,
      });
    } catch (err) {
      console.error(" Failed fetching Top Dish API:", err);
      return null;
    }
  },

  getPaymentSplit: async (params) => {
    try {
      return await apiClient.get(ENDPOINTS.DASHBOARD.GET_PAYMENT_SPLIT, {
        params,
      });
    } catch (err) {
      console.error("Failed fetching payment split:", err);
      return { cashPercent: 0, onlinePercent: 0 };
    }
  },

  getRevenueSummary: async (params) => {
    try {
      return await apiClient.get(ENDPOINTS.DASHBOARD.GET_REVENUE_SUMMARY, {
        params,
      });
    } catch (err) {
      console.error(" Failed fetching revenue summary:", err);
      return { currentRevenue: 0, previousRevenue: 0, growthPercentage: 0 };
    }
  },

  getFinancialSnapshot: async (params) => {
    try {
      return await apiClient.get(ENDPOINTS.DASHBOARD.GET_FINANCIAL_SNAPSHOT, {
        params,
      });
    } catch (err) {
      console.error("Failed fetching financial snapshot:", err);
      return { totalRevenue: 0, totalDiscount: 0, totalNcAmount: 0, totalTax: 0, grossSales: 0 };
    }
  },

  getOrdersSummary: async (params) => {
    try {
      return await apiClient.get(ENDPOINTS.DASHBOARD.GET_ORDERS_SUMMARY, {
        params,
      });
    } catch (err) {
      console.error(" Failed fetching orders summary:", err);
      return { currentOrders: 0, previousOrders: 0, growthPercentage: 0 };
    }
  },

};

export default dashboardService;
